module.exports = __webpack_public_path__ + "static/woody_consult-15434d0526c977312c095c69c7fda024.jpg";